module.exports = __webpack_public_path__ + "img/banner-welcome-bonus.abb7e6c3.png";